import { render, staticRenderFns } from "./FloodSensitivityProperty.vue?vue&type=template&id=6d7c60d8&"
import script from "./FloodSensitivityProperty.vue?vue&type=script&lang=ts&"
export * from "./FloodSensitivityProperty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports